export class BaseScenarioData {
}
